import Button from "../../components/Button/Button";
import NavBar from "../../components/NavBar/NavBar";
import "./HomePage.scss";
import heroFrcophthTopics from "../../assets/oq/hero-frcophth-topics.png";
import { Button as BootstrapButton } from "react-bootstrap";

import Footer from "../../components/Footer/Footer";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import products from "../SignUpPage/products";
import { FaExternalLinkAlt, FaFileAlt, FaPenFancy, FaQuoteLeft } from "react-icons/fa";
import { ESSAY_PRIZE_CLOSING_DATE, ESSAY_PRIZES_OVERVIEW_PATH } from "../NationalEssayPrizesPage/essayPrizes";

const OqHomePage = () => {
  const { hash } = useLocation();
  const navigate = useNavigate();

  const newsletterFormSubmitted = (event: React.FormEvent) => {
    event.preventDefault();
    console.log(event);
  };

  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView();
      }
    } else {
      window.scrollTo(0, 0);
    }
  }, [hash]);

  return (
    <div id="OqHomePage">
      <NavBar />

      <section className="home-hero" aria-label="Introduction">
        <div className="site-container home-hero__inner">
          <div className="home-hero__copy">
            <p className="home-eyebrow">FRCOphth · MSRA · Interviews</p>
            <h1 className="home-hero__title">Master the FRCOphth exams</h1>
            <p className="home-hero__lead">
              Prepare for <strong>FRCOphth Parts 1 &amp; 2</strong>, the <strong>MSRA</strong>, and{" "}
              <strong>ST1 ophthalmology interviews</strong> with <strong>exam-style questions</strong> that mirror
              real papers in <strong>wording and format</strong>, <strong>timed mock exams</strong> when you are ready,
              and explanations grounded in UK practice. <strong>Co-built by ophthalmologists, for ophthalmologists.</strong>
            </p>
            <div className="home-hero__actions">
              <div className="home-hero__signup">
                <Button text="Sign up" linkTo="/sign-up" />
              </div>
            </div>
            <p className="home-hero__trust">
              Exam-realistic format · UK-aligned explanations · Built with practising ophthalmologists
            </p>
          </div>
          <div className="home-hero__visual">
            <img
              className="home-hero__image"
              src={heroFrcophthTopics}
              alt="FRCOphth Part 1 Topics dashboard with modules, progress, and practice options"
              width={1024}
              height={732}
              loading="eager"
              decoding="async"
            />
          </div>
        </div>
      </section>

      <div id="other-sections" className="home-body">
        <section className="home-section home-essay-prize" aria-labelledby="home-essay-prize-heading">
          <div className="home-essay-prize__card">
            <div className="home-essay-prize__inner">
              <div className="home-essay-prize__decor" aria-hidden="true">
                <FaQuoteLeft className="home-essay-prize__decor-quote" />
                <FaPenFancy className="home-essay-prize__decor-pen" />
                <FaFileAlt className="home-essay-prize__decor-page" />
              </div>

              <div className="home-essay-prize__layout">
                <div className="home-essay-prize__content">
                  <div className="home-essay-prize__badges">
                    <span className="home-essay-prize__prize-badge">£500 × 2</span>
                    <span className="home-essay-prize__deadline-badge">
                      Close {ESSAY_PRIZE_CLOSING_DATE}
                    </span>
                  </div>
                  <p className="home-essay-prize__eyebrow">National competition · 2026</p>
                  <h2 id="home-essay-prize-heading" className="home-essay-prize__title">
                    National <span className="home-essay-prize__title-accent">Essay Prizes</span>
                  </h2>
                  <p className="home-essay-prize__lead">
                    Share your perspective on the future of ophthalmology and compete for{" "}
                    <strong>two £500 national prizes</strong>. Open to UK medical students, foundation
                    doctors, specialty trainees, and fellows—choose the category that fits your career stage.
                  </p>
                  <div className="home-essay-prize__actions">
                    <Button text="View essay prizes" linkTo={ESSAY_PRIZES_OVERVIEW_PATH} type="navy" />
                  </div>
                </div>

                <div className="home-essay-prize__visual" aria-hidden="true">
                  <div className="home-essay-prize__visual-card home-essay-prize__visual-card--gold">
                    <FaPenFancy />
                    <span className="home-essay-prize__visual-amount">£500</span>
                    <span className="home-essay-prize__visual-label">Essay prize</span>
                  </div>
                  <div className="home-essay-prize__visual-card home-essay-prize__visual-card--navy">
                    <FaFileAlt />
                    <span className="home-essay-prize__visual-label">Your essay</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="pricing" className="home-section home-pricing">
          <div className="site-container">
            <p className="home-section__label home-section__label--center">Question banks &amp; resources</p>
            <h2 className="home-section__title home-section__title--center">Choose your preparation</h2>
            <p className="home-pricing__intro">
              <strong>FRCOphth Part 1 &amp; Part 2</strong> banks deliver <strong>every module and every area</strong> in
              exam-realistic form; add <strong>MSRA</strong>, interview packs, or <strong>coaching from leading UK
              ophthalmologists</strong> to match how you learn. Pick a product for full detail and pricing.
            </p>

            <div className="oq-product-cards-wrapper">
              {products.map((product) => {
                const isPurchasable = !((product as { purchasable?: boolean }).purchasable === false);
                const externalPurchaseUrl = (product as { externalPurchaseUrl?: string }).externalPurchaseUrl;
                const showAmazonPurchase = product.id === "duke_elder" && externalPurchaseUrl;
                const button = (
                  <>
                    <BootstrapButton
                      className="home-product-btn home-product-btn--primary"
                      onClick={() => {
                        navigate("/products/" + product.id);
                      }}
                    >
                      Learn more
                    </BootstrapButton>
                    {showAmazonPurchase && (
                      <BootstrapButton
                        className="home-product-btn home-product-btn--external"
                        aria-label="Purchase on Amazon (opens in new tab)"
                        onClick={() => {
                          window.open(externalPurchaseUrl, "_blank", "noopener,noreferrer");
                        }}
                      >
                        <span className="home-product-btn__label">
                          Purchase
                          <FaExternalLinkAlt className="home-product-btn__link-icon" aria-hidden />
                        </span>
                      </BootstrapButton>
                    )}
                    {isPurchasable && !product.comingSoon && !showAmazonPurchase && (
                      <BootstrapButton
                        className="home-product-btn home-product-btn--secondary"
                        onClick={() => {
                          const checkoutUrl = (product as { checkoutUrl?: string }).checkoutUrl;
                          if (checkoutUrl) {
                            window.open(checkoutUrl, "_blank", "noopener,noreferrer");
                          } else {
                            navigate("/sign-up?product=" + product.id);
                          }
                        }}
                      >
                        Purchase
                      </BootstrapButton>
                    )}
                  </>
                );
                return (
                  <div className={`oq-product-card ${product.css}`} key={product.id}>
                    <h5>{product.title}</h5>
                    <p>{product.description}</p>
                    <p className="oq-product-card-pricing">
                      {product.price ? (
                        <>
                          <span>£{product.price}</span> / {product.length}
                          {product.comingSoon && (
                            <span
                              className={
                                product.id === "portfolio_builder"
                                  ? "coming-soon-pill coming-soon-pill--pink"
                                  : "coming-soon-pill"
                              }
                            >
                              coming soon
                            </span>
                          )}
                        </>
                      ) : (
                        <>
                          <span
                            style={{
                              visibility: "hidden",
                            }}
                          >
                            £
                          </span>
                        </>
                      )}
                    </p>
                    <div className="home-product-card__actions">{button}</div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        <section id="newsletter" className="home-section home-newsletter">
          <div className="site-container">
            <p className="home-newsletter__label">Stay informed</p>
            <h2 className="home-section__title home-section__title--center">Newsletter</h2>
            <p className="home-newsletter__text">
              Occasional updates on new questions, syllabus changes, and study strategy—no clutter.
            </p>

            <form className="home-newsletter__form" onSubmit={newsletterFormSubmitted}>
              <input type="email" name="email" placeholder="you@hospital.nhs.uk" autoComplete="email" />
              <div className="home-newsletter__submit">
                <Button text="Subscribe" submit />
              </div>
            </form>
          </div>
        </section>
        <Footer />
      </div>
    </div>
  );
};

export default OqHomePage;
